/* src/services/auth.js */
import apiClient from './api'

export const authServiceAdmin = {

  async login(username, password) {

    try {

      const response = await apiClient.post('/operators/auth/login/', {
        username: username.trim(),
        password: password.trim()
      })


      if (response.data && response.data.token) {

        localStorage.setItem('admin_token', response.data.token)
        apiClient.defaults.headers.common['Authorization'] = `Token ${response.data.token}`
      }
      
      console.log("Login eseguito con successo:", response.data)
      return response.data
      
    } 
    catch (error) {

      console.error("Errore durante il login:", error.response?.data || error.message)
      throw error
    }
  },

  logout() {

    localStorage.removeItem('admin_token')
    localStorage.removeItem('user_token')
    delete apiClient.defaults.headers.common['Authorization']
  },

  isAuthenticated() {

    return !!localStorage.getItem('admin_token')
  }
}